import router from "js/routes/router"
import urls from "js/routes/urls"
import { DEFAULT_VIEW } from "js/routes/urls"

export default (name = DEFAULT_VIEW, params = {}) =>
    router.push(urls[name].navigate(params))
